import { dataApiUrl } from 'utils/url';
import AuthAxios from 'utils/authAxios';

const DataApiUrl = dataApiUrl();

const RecoupAccountTracks = () => {
  const create = (recoup_account_id, asset_track_id) =>
    AuthAxios.post(`${DataApiUrl}/admin/recoupAccounts/${recoup_account_id}/tracks`, { asset_track_id })
      .then(res => res.data.data)
      .catch(err => {
        throw err.response;
      });
  const del = id =>
    AuthAxios.delete(`${DataApiUrl}/admin/recoupAccountTracks/${id}`)
      .then(res => res.data.data)
      .catch(err => {
        throw err.response;
      });
  return {
    create,
    del,
  };
};
export default RecoupAccountTracks;
